module.exports = __webpack_public_path__ + "static/media/sarvvid_logo_notext.a7981c36.svg";